import { __ } from "@wordpress/i18n";

export const FONT_FAMILYS = [
    { label: __("Default", "current-date"), value: "Default" },
    { label: __("ABeeZee", "current-date"), value: "ABeeZee" },
    { label: __("Abel", "current-date"), value: "Abel" },
    { label: __("Abhaya Libre", "current-date"), value: "Abhaya Libre" },
    { label: __("Abril Fatface", "current-date"), value: "Abril Fatface" },
    { label: __("Abyssinica SIL", "current-date"), value: "Abyssinica SIL" },
    { label: __("Aclonica", "current-date"), value: "Aclonica" },
    { label: __("Acme", "current-date"), value: "Acme" },
    { label: __("Actor", "current-date"), value: "Actor" },
    { label: __("Adamina", "current-date"), value: "Adamina" },
    { label: __("Adobe Blank", "current-date"), value: "Adobe Blank" },
    { label: __("Advent Pro", "current-date"), value: "Advent Pro" },
    { label: __("Aguafina Script", "current-date"), value: "Aguafina Script" },
    { label: __("Akronim", "current-date"), value: "Akronim" },
    { label: __("aksarabaligalang", "current-date"), value: "aksarabaligalang" },
    { label: __("Aladin", "current-date"), value: "Aladin" },
    { label: __("Aldrich", "current-date"), value: "Aldrich" },
    { label: __("Alef", "current-date"), value: "Alef" },
    { label: __("alefhebrew", "current-date"), value: "alefhebrew" },
    { label: __("Alegreya", "current-date"), value: "Alegreya" },
    { label: __("Alegreya Sans", "current-date"), value: "Alegreya Sans" },
    { label: __("Alegreya Sans SC", "current-date"), value: "Alegreya Sans SC" },
    { label: __("Alegreya SC", "current-date"), value: "Alegreya SC" },
    { label: __("Aleo", "current-date"), value: "Aleo" },
    { label: __("Alex Brush", "current-date"), value: "Alex Brush" },
    { label: __("Alfa Slab One", "current-date"), value: "Alfa Slab One" },
    { label: __("Alice", "current-date"), value: "Alice" },
    { label: __("Alike", "current-date"), value: "Alike" },
    { label: __("Alike Angular", "current-date"), value: "Alike Angular" },
    { label: __("Allan", "current-date"), value: "Allan" },
    { label: __("Allerta", "current-date"), value: "Allerta" },
    { label: __("Allerta Stencil", "current-date"), value: "Allerta Stencil" },
    { label: __("Allura", "current-date"), value: "Allura" },
    { label: __("Almendra", "current-date"), value: "Almendra" },
    { label: __("Almendra Display", "current-date"), value: "Almendra Display" },
    { label: __("Almendra SC", "current-date"), value: "Almendra SC" },
    { label: __("Amarante", "current-date"), value: "Amarante" },
    { label: __("Amaranth", "current-date"), value: "Amaranth" },
    { label: __("Amatic SC", "current-date"), value: "Amatic SC" },
    { label: __("Amethysta", "current-date"), value: "Amethysta" },
    { label: __("Amiko", "current-date"), value: "Amiko" },
    { label: __("Amiri", "current-date"), value: "Amiri" },
    { label: __("Amita", "current-date"), value: "Amita" },
    { label: __("amstelvaralpha", "current-date"), value: "amstelvaralpha" },
    { label: __("Anaheim", "current-date"), value: "Anaheim" },
    { label: __("Andada", "current-date"), value: "Andada" },
    { label: __("Andada SC", "current-date"), value: "Andada SC" },
    { label: __("Andika", "current-date"), value: "Andika" },
    { label: __("Angkor", "current-date"), value: "Angkor" },
    { label: __("Annie Use Your Telescope", "current-date"), value: "Annie Use Your Telescope" },
    { label: __("Anonymous Pro", "current-date"), value: "Anonymous Pro" },
    { label: __("Antic", "current-date"), value: "Antic" },
    { label: __("Antic Didone", "current-date"), value: "Antic Didone" },
    { label: __("Antic Slab", "current-date"), value: "Antic Slab" },
    { label: __("Anton", "current-date"), value: "Anton" },
    { label: __("Antonio", "current-date"), value: "Antonio" },
    { label: __("Arapey", "current-date"), value: "Arapey" },
    { label: __("Arbutus", "current-date"), value: "Arbutus" },
    { label: __("Arbutus Slab", "current-date"), value: "Arbutus Slab" },
    { label: __("Architects Daughter", "current-date"), value: "Architects Daughter" },
    { label: __("Archivo", "current-date"), value: "Archivo" },
    { label: __("Archivo Black", "current-date"), value: "Archivo Black" },
    { label: __("Archivo Narrow", "current-date"), value: "Archivo Narrow" },
    { label: __("archivovfbeta", "current-date"), value: "archivovfbeta" },
    { label: __("Aref Ruqaa", "current-date"), value: "Aref Ruqaa" },
    { label: __("Arima Madurai", "current-date"), value: "Arima Madurai" },
    { label: __("Arimo", "current-date"), value: "Arimo" },
    { label: __("Arizonia", "current-date"), value: "Arizonia" },
    { label: __("Armata", "current-date"), value: "Armata" },
    { label: __("Arsenal", "current-date"), value: "Arsenal" },
    { label: __("Artifika", "current-date"), value: "Artifika" },
    { label: __("Arvo", "current-date"), value: "Arvo" },
    { label: __("Arya", "current-date"), value: "Arya" },
    { label: __("Asap", "current-date"), value: "Asap" },
    { label: __("Asap Condensed", "current-date"), value: "Asap Condensed" },
    { label: __("asapvfbeta", "current-date"), value: "asapvfbeta" },
    { label: __("Asar", "current-date"), value: "Asar" },
    { label: __("Asset", "current-date"), value: "Asset" },
    { label: __("Assistant", "current-date"), value: "Assistant" },
    { label: __("Astloch", "current-date"), value: "Astloch" },
    { label: __("Asul", "current-date"), value: "Asul" },
    { label: __("Athiti", "current-date"), value: "Athiti" },
    { label: __("Atomic Age", "current-date"), value: "Atomic Age" },
    { label: __("Aubrey", "current-date"), value: "Aubrey" },
    { label: __("Audiowide", "current-date"), value: "Audiowide" },
    { label: __("Autour One", "current-date"), value: "Autour One" },
    { label: __("Average", "current-date"), value: "Average" },
    { label: __("Average Sans", "current-date"), value: "Average Sans" },
    { label: __("Averia Gruesa Libre", "current-date"), value: "Averia Gruesa Libre" },
    { label: __("Averia Libre", "current-date"), value: "Averia Libre" },
    { label: __("Averia Sans Libre", "current-date"), value: "Averia Sans Libre" },
    { label: __("Averia Serif Libre", "current-date"), value: "Averia Serif Libre" },
    { label: __("B612", "current-date"), value: "B612" },
    { label: __("B612 Mono", "current-date"), value: "B612 Mono" },
    { label: __("Bad Script", "current-date"), value: "Bad Script" },
    { label: __("Bahiana", "current-date"), value: "Bahiana" },
    { label: __("Bahianita", "current-date"), value: "Bahianita" },
    { label: __("Bai Jamjuree", "current-date"), value: "Bai Jamjuree" },
    { label: __("Baloo", "current-date"), value: "Baloo" },
    { label: __("Baloo Bhai", "current-date"), value: "Baloo Bhai" },
    { label: __("Baloo Bhaijaan", "current-date"), value: "Baloo Bhaijaan" },
    { label: __("Baloo Bhaina", "current-date"), value: "Baloo Bhaina" },
    { label: __("Baloo Chettan", "current-date"), value: "Baloo Chettan" },
    { label: __("Baloo Da", "current-date"), value: "Baloo Da" },
    { label: __("Baloo Paaji", "current-date"), value: "Baloo Paaji" },
    { label: __("Baloo Tamma", "current-date"), value: "Baloo Tamma" },
    { label: __("Baloo Tammudu", "current-date"), value: "Baloo Tammudu" },
    { label: __("Baloo Thambi", "current-date"), value: "Baloo Thambi" },
    { label: __("Balthazar", "current-date"), value: "Balthazar" },
    { label: __("Bangers", "current-date"), value: "Bangers" },
    { label: __("Barlow", "current-date"), value: "Barlow" },
    { label: __("Barlow Condensed", "current-date"), value: "Barlow Condensed" },
    { label: __("Barlow Semi Condensed", "current-date"), value: "Barlow Semi Condensed" },
    { label: __("Barriecito", "current-date"), value: "Barriecito" },
    { label: __("Barrio", "current-date"), value: "Barrio" },
    { label: __("Basic", "current-date"), value: "Basic" },
    { label: __("Battambang", "current-date"), value: "Battambang" },
    { label: __("Baumans", "current-date"), value: "Baumans" },
    { label: __("Bayon", "current-date"), value: "Bayon" },
    { label: __("Belgrano", "current-date"), value: "Belgrano" },
    { label: __("Bellefair", "current-date"), value: "Bellefair" },
    { label: __("Belleza", "current-date"), value: "Belleza" },
    { label: __("BenchNine", "current-date"), value: "BenchNine" },
    { label: __("Bentham", "current-date"), value: "Bentham" },
    { label: __("Berkshire Swash", "current-date"), value: "Berkshire Swash" },
    { label: __("Beth Ellen", "current-date"), value: "Beth Ellen" },
    { label: __("Bevan", "current-date"), value: "Bevan" },
    { label: __("Bhavuka", "current-date"), value: "Bhavuka" },
    { label: __("Bigelow Rules", "current-date"), value: "Bigelow Rules" },
    { label: __("Bigshot One", "current-date"), value: "Bigshot One" },
    { label: __("Bilbo", "current-date"), value: "Bilbo" },
    { label: __("Bilbo Swash Caps", "current-date"), value: "Bilbo Swash Caps" },
    { label: __("Bio Rhyme", "current-date"), value: "Bio Rhyme" },
    { label: __("Bio Rhyme Expanded", "current-date"), value: "Bio Rhyme Expanded" },
    { label: __("Biryani", "current-date"), value: "Biryani" },
    { label: __("Bitter", "current-date"), value: "Bitter" },
    { label: __("Black And White Picture", "current-date"), value: "Black And White Picture" },
    { label: __("Black Han Sans", "current-date"), value: "Black Han Sans" },
    { label: __("Black Ops One", "current-date"), value: "Black Ops One" },
    { label: __("Bokor", "current-date"), value: "Bokor" },
    { label: __("Bonbon", "current-date"), value: "Bonbon" },
    { label: __("Boogaloo", "current-date"), value: "Boogaloo" },
    { label: __("Bowlby One", "current-date"), value: "Bowlby One" },
    { label: __("Bowlby One SC", "current-date"), value: "Bowlby One SC" },
    { label: __("Brawler", "current-date"), value: "Brawler" },
    { label: __("Bree Serif", "current-date"), value: "Bree Serif" },
    { label: __("Bruno Ace", "current-date"), value: "Bruno Ace" },
    { label: __("Bruno Ace SC", "current-date"), value: "Bruno Ace SC" },
    { label: __("Bubblegum Sans", "current-date"), value: "Bubblegum Sans" },
    { label: __("Bubbler One", "current-date"), value: "Bubbler One" },
    { label: __("Buda", "current-date"), value: "Buda" },
    { label: __("Buenard", "current-date"), value: "Buenard" },
    { label: __("Bungee", "current-date"), value: "Bungee" },
    { label: __("Bungee Hairline", "current-date"), value: "Bungee Hairline" },
    { label: __("Bungee Inline", "current-date"), value: "Bungee Inline" },
    { label: __("Bungee Outline", "current-date"), value: "Bungee Outline" },
    { label: __("Bungee Shade", "current-date"), value: "Bungee Shade" },
    { label: __("Butcherman", "current-date"), value: "Butcherman" },
    { label: __("Butcherman Caps", "current-date"), value: "Butcherman Caps" },
    { label: __("Butterfly Kids", "current-date"), value: "Butterfly Kids" },
    { label: __("Cabin", "current-date"), value: "Cabin" },
    { label: __("Cabin Condensed", "current-date"), value: "Cabin Condensed" },
    { label: __("Cabin Sketch", "current-date"), value: "Cabin Sketch" },
    { label: __("cabinvfbeta", "current-date"), value: "cabinvfbeta" },
    { label: __("Caesar Dressing", "current-date"), value: "Caesar Dressing" },
    { label: __("Cagliostro", "current-date"), value: "Cagliostro" },
    { label: __("Cairo", "current-date"), value: "Cairo" },
    { label: __("Calligraffitti", "current-date"), value: "Calligraffitti" },
    { label: __("Cambay", "current-date"), value: "Cambay" },
    { label: __("Cambo", "current-date"), value: "Cambo" },
    { label: __("Candal", "current-date"), value: "Candal" },
    { label: __("Cantarell", "current-date"), value: "Cantarell" },
    { label: __("Cantata One", "current-date"), value: "Cantata One" },
    { label: __("Cantora One", "current-date"), value: "Cantora One" },
    { label: __("Capriola", "current-date"), value: "Capriola" },
    { label: __("Cardo", "current-date"), value: "Cardo" },
    { label: __("Carme", "current-date"), value: "Carme" },
    { label: __("Carrois Gothic", "current-date"), value: "Carrois Gothic" },
    { label: __("Carrois Gothic SC", "current-date"), value: "Carrois Gothic SC" },
    { label: __("Carter One", "current-date"), value: "Carter One" },
    { label: __("Catamaran", "current-date"), value: "Catamaran" },
    { label: __("Caudex", "current-date"), value: "Caudex" },
    { label: __("Caveat", "current-date"), value: "Caveat" },
    { label: __("Caveat Brush", "current-date"), value: "Caveat Brush" },
    { label: __("Cedarville Cursive", "current-date"), value: "Cedarville Cursive" },
    { label: __("Ceviche One", "current-date"), value: "Ceviche One" },
    { label: __("Chakra Petch", "current-date"), value: "Chakra Petch" },
    { label: __("Changa", "current-date"), value: "Changa" },
    { label: __("Changa One", "current-date"), value: "Changa One" },
    { label: __("Chango", "current-date"), value: "Chango" },
    { label: __("Charm", "current-date"), value: "Charm" },
    { label: __("Charmonman", "current-date"), value: "Charmonman" },
    { label: __("Chau Philomene One", "current-date"), value: "Chau Philomene One" },
    { label: __("Chela One", "current-date"), value: "Chela One" },
    { label: __("Chelsea Market", "current-date"), value: "Chelsea Market" },
    { label: __("Chenla", "current-date"), value: "Chenla" },
    { label: __("Cherry Cream Soda", "current-date"), value: "Cherry Cream Soda" },
    { label: __("Cherry Swash", "current-date"), value: "Cherry Swash" },
    { label: __("Chewy", "current-date"), value: "Chewy" },
    { label: __("Chicle", "current-date"), value: "Chicle" },
    { label: __("Chilanka", "current-date"), value: "Chilanka" },
    { label: __("Chivo", "current-date"), value: "Chivo" },
    { label: __("Chonburi", "current-date"), value: "Chonburi" },
    { label: __("Cinzel", "current-date"), value: "Cinzel" },
    { label: __("Cinzel Decorative", "current-date"), value: "Cinzel Decorative" },
    { label: __("Clicker Script", "current-date"), value: "Clicker Script" },
    { label: __("Coda", "current-date"), value: "Coda" },
    { label: __("Coda Caption", "current-date"), value: "Coda Caption" },
    { label: __("Codystar", "current-date"), value: "Codystar" },
    { label: __("Coiny", "current-date"), value: "Coiny" },
    { label: __("Combo", "current-date"), value: "Combo" },
    { label: __("Comfortaa", "current-date"), value: "Comfortaa" },
    { label: __("Coming Soon", "current-date"), value: "Coming Soon" },
    { label: __("Concert One", "current-date"), value: "Concert One" },
    { label: __("Condiment", "current-date"), value: "Condiment" },
    { label: __("Content", "current-date"), value: "Content" },
    { label: __("Contrail One", "current-date"), value: "Contrail One" },
    { label: __("Convergence", "current-date"), value: "Convergence" },
    { label: __("Cookie", "current-date"), value: "Cookie" },
    { label: __("Copse", "current-date"), value: "Copse" },
    { label: __("Corben", "current-date"), value: "Corben" },
    { label: __("Cormorant", "current-date"), value: "Cormorant" },
    { label: __("Cormorant Garamond", "current-date"), value: "Cormorant Garamond" },
    { label: __("Cormorant Infant", "current-date"), value: "Cormorant Infant" },
    { label: __("Cormorant SC", "current-date"), value: "Cormorant SC" },
    { label: __("Cormorant Unicase", "current-date"), value: "Cormorant Unicase" },
    { label: __("Cormorant Upright", "current-date"), value: "Cormorant Upright" },
    { label: __("Courgette", "current-date"), value: "Courgette" },
    { label: __("Cousine", "current-date"), value: "Cousine" },
    { label: __("Coustard", "current-date"), value: "Coustard" },
    { label: __("Covered By Your Grace", "current-date"), value: "Covered By Your Grace" },
    { label: __("Crafty Girls", "current-date"), value: "Crafty Girls" },
    { label: __("Creepster", "current-date"), value: "Creepster" },
    { label: __("Creepster Caps", "current-date"), value: "Creepster Caps" },
    { label: __("Crete Round", "current-date"), value: "Crete Round" },
    { label: __("Crimson Pro", "current-date"), value: "Crimson Pro" },
    { label: __("Crimson Text", "current-date"), value: "Crimson Text" },
    { label: __("Croissant One", "current-date"), value: "Croissant One" },
    { label: __("Crushed", "current-date"), value: "Crushed" },
    { label: __("Cuprum", "current-date"), value: "Cuprum" },
    { label: __("Cute Font", "current-date"), value: "Cute Font" },
    { label: __("Cutive", "current-date"), value: "Cutive" },
    { label: __("Cutive Mono", "current-date"), value: "Cutive Mono" },
    { label: __("Damion", "current-date"), value: "Damion" },
    { label: __("Dancing Script", "current-date"), value: "Dancing Script" },
    { label: __("Dangrek", "current-date"), value: "Dangrek" },
    { label: __("Darker Grotesque", "current-date"), value: "Darker Grotesque" },
    { label: __("Dawning of a New Day", "current-date"), value: "Dawning of a New Day" },
    { label: __("Days One", "current-date"), value: "Days One" },
    { label: __("decovaralpha", "current-date"), value: "decovaralpha" },
    { label: __("Dekko", "current-date"), value: "Dekko" },
    { label: __("Delius", "current-date"), value: "Delius" },
    { label: __("Delius Swash Caps", "current-date"), value: "Delius Swash Caps" },
    { label: __("Delius Unicase", "current-date"), value: "Delius Unicase" },
    { label: __("Della Respira", "current-date"), value: "Della Respira" },
    { label: __("Denk One", "current-date"), value: "Denk One" },
    { label: __("Devonshire", "current-date"), value: "Devonshire" },
    { label: __("Dhurjati", "current-date"), value: "Dhurjati" },
    { label: __("Dhyana", "current-date"), value: "Dhyana" },
    { label: __("Didact Gothic", "current-date"), value: "Didact Gothic" },
    { label: __("Digital Numbers", "current-date"), value: "Digital Numbers" },
    { label: __("Diplomata", "current-date"), value: "Diplomata" },
    { label: __("Diplomata SC", "current-date"), value: "Diplomata SC" },
    { label: __("DM Sans", "current-date"), value: "DM Sans" },
    { label: __("DM Serif Display", "current-date"), value: "DM Serif Display" },
    { label: __("DM Serif Text", "current-date"), value: "DM Serif Text" },
    { label: __("Do Hyeon", "current-date"), value: "Do Hyeon" },
    { label: __("Dokdo", "current-date"), value: "Dokdo" },
    { label: __("Domine", "current-date"), value: "Domine" },
    { label: __("Donegal One", "current-date"), value: "Donegal One" },
    { label: __("Doppio One", "current-date"), value: "Doppio One" },
    { label: __("Dorsa", "current-date"), value: "Dorsa" },
    { label: __("Dosis", "current-date"), value: "Dosis" },
    { label: __("Dr Sugiyama", "current-date"), value: "Dr Sugiyama" },
    { label: __("Duru Sans", "current-date"), value: "Duru Sans" },
    { label: __("Dynalight", "current-date"), value: "Dynalight" },
    { label: __("Eagle Lake", "current-date"), value: "Eagle Lake" },
    { label: __("East Sea Dokdo", "current-date"), value: "East Sea Dokdo" },
    { label: __("Eater", "current-date"), value: "Eater" },
    { label: __("Eater Caps", "current-date"), value: "Eater Caps" },
    { label: __("EB Garamond", "current-date"), value: "EB Garamond" },
    { label: __("Economica", "current-date"), value: "Economica" },
    { label: __("Eczar", "current-date"), value: "Eczar" },
    { label: __("Ek Mukta", "current-date"), value: "Ek Mukta" },
    { label: __("El Messiri", "current-date"), value: "El Messiri" },
    { label: __("Electrolize", "current-date"), value: "Electrolize" },
    { label: __("Elsie", "current-date"), value: "Elsie" },
    { label: __("Elsie Swash Caps", "current-date"), value: "Elsie Swash Caps" },
    { label: __("Emblema One", "current-date"), value: "Emblema One" },
    { label: __("Emilys Candy", "current-date"), value: "Emilys Candy" },
    { label: __("Encode Sans", "current-date"), value: "Encode Sans" },
    { label: __("Encode Sans Condensed", "current-date"), value: "Encode Sans Condensed" },
    { label: __("Encode Sans Expanded", "current-date"), value: "Encode Sans Expanded" },
    { label: __("Encode Sans Semi Condensed", "current-date"), value: "Encode Sans Semi Condensed" },
    { label: __("Encode Sans Semi Expanded", "current-date"), value: "Encode Sans Semi Expanded" },
    { label: __("Engagement", "current-date"), value: "Engagement" },
    { label: __("Englebert", "current-date"), value: "Englebert" },
    { label: __("Enriqueta", "current-date"), value: "Enriqueta" },
    { label: __("Erica One", "current-date"), value: "Erica One" },
    { label: __("Esteban", "current-date"), value: "Esteban" },
    { label: __("Euphoria Script", "current-date"), value: "Euphoria Script" },
    { label: __("Ewert", "current-date"), value: "Ewert" },
    { label: __("Exo", "current-date"), value: "Exo" },
    { label: __("Exo 2", "current-date"), value: "Exo 2" },
    { label: __("Expletus Sans", "current-date"), value: "Expletus Sans" },
    { label: __("Fahkwang", "current-date"), value: "Fahkwang" },
    { label: __("Fanwood Text", "current-date"), value: "Fanwood Text" },
    { label: __("Farro", "current-date"), value: "Farro" },
    { label: __("Farsan", "current-date"), value: "Farsan" },
    { label: __("Fascinate", "current-date"), value: "Fascinate" },
    { label: __("Fascinate Inline", "current-date"), value: "Fascinate Inline" },
    { label: __("Faster One", "current-date"), value: "Faster One" },
    { label: __("Fasthand", "current-date"), value: "Fasthand" },
    { label: __("Fauna One", "current-date"), value: "Fauna One" },
    { label: __("Faustina", "current-date"), value: "Faustina" },
    { label: __("faustinavfbeta", "current-date"), value: "faustinavfbeta" },
    { label: __("Federant", "current-date"), value: "Federant" },
    { label: __("Federo", "current-date"), value: "Federo" },
    { label: __("Felipa", "current-date"), value: "Felipa" },
    { label: __("Fenix", "current-date"), value: "Fenix" },
    { label: __("Finger Paint", "current-date"), value: "Finger Paint" },
    { label: __("Fira Code", "current-date"), value: "Fira Code" },
    { label: __("Fira Mono", "current-date"), value: "Fira Mono" },
    { label: __("Fira Sans", "current-date"), value: "Fira Sans" },
    { label: __("Fira Sans Condensed", "current-date"), value: "Fira Sans Condensed" },
    { label: __("Fira Sans Extra Condensed", "current-date"), value: "Fira Sans Extra Condensed" },
    { label: __("Fjalla One", "current-date"), value: "Fjalla One" },
    { label: __("Fjord One", "current-date"), value: "Fjord One" },
    { label: __("Flamenco", "current-date"), value: "Flamenco" },
    { label: __("Flavors", "current-date"), value: "Flavors" },
    { label: __("Fondamento", "current-date"), value: "Fondamento" },
    { label: __("Fontdiner Swanky", "current-date"), value: "Fontdiner Swanky" },
    { label: __("Forum", "current-date"), value: "Forum" },
    { label: __("Francois One", "current-date"), value: "Francois One" },
    { label: __("Frank Ruhl Libre", "current-date"), value: "Frank Ruhl Libre" },
    { label: __("Freckle Face", "current-date"), value: "Freckle Face" },
    { label: __("Fredericka the Great", "current-date"), value: "Fredericka the Great" },
    { label: __("Fredoka One", "current-date"), value: "Fredoka One" },
    { label: __("Freehand", "current-date"), value: "Freehand" },
    { label: __("Fresca", "current-date"), value: "Fresca" },
    { label: __("Frijole", "current-date"), value: "Frijole" },
    { label: __("Fruktur", "current-date"), value: "Fruktur" },
    { label: __("Fugaz One", "current-date"), value: "Fugaz One" },
    { label: __("Gabriela", "current-date"), value: "Gabriela" },
    { label: __("Gaegu", "current-date"), value: "Gaegu" },
    { label: __("Gafata", "current-date"), value: "Gafata" },
    { label: __("Galada", "current-date"), value: "Galada" },
    { label: __("Galdeano", "current-date"), value: "Galdeano" },
    { label: __("Galindo", "current-date"), value: "Galindo" },
    { label: __("Gamja Flower", "current-date"), value: "Gamja Flower" },
    { label: __("Gayathri", "current-date"), value: "Gayathri" },
    { label: __("Gemunu Libre", "current-date"), value: "Gemunu Libre" },
    { label: __("Gentium Basic", "current-date"), value: "Gentium Basic" },
    { label: __("Gentium Book Basic", "current-date"), value: "Gentium Book Basic" },
    { label: __("Geo", "current-date"), value: "Geo" },
    { label: __("Geostar", "current-date"), value: "Geostar" },
    { label: __("Geostar Fill", "current-date"), value: "Geostar Fill" },
    { label: __("Germania One", "current-date"), value: "Germania One" },
    { label: __("GFS Didot", "current-date"), value: "GFS Didot" },
    { label: __("GFS Neohellenic", "current-date"), value: "GFS Neohellenic" },
    { label: __("Gidugu", "current-date"), value: "Gidugu" },
    { label: __("Gilda Display", "current-date"), value: "Gilda Display" },
    { label: __("Give You Glory", "current-date"), value: "Give You Glory" },
    { label: __("Glass Antiqua", "current-date"), value: "Glass Antiqua" },
    { label: __("Glegoo", "current-date"), value: "Glegoo" },
    { label: __("Gloria Hallelujah", "current-date"), value: "Gloria Hallelujah" },
    { label: __("Goblin One", "current-date"), value: "Goblin One" },
    { label: __("Gochi Hand", "current-date"), value: "Gochi Hand" },
    { label: __("Gorditas", "current-date"), value: "Gorditas" },
    { label: __("Gothic A1", "current-date"), value: "Gothic A1" },
    { label: __("Goudy Bookletter 1911", "current-date"), value: "Goudy Bookletter 1911" },
    { label: __("Graduate", "current-date"), value: "Graduate" },
    { label: __("Grand Hotel", "current-date"), value: "Grand Hotel" },
    { label: __("Gravitas One", "current-date"), value: "Gravitas One" },
    { label: __("Great Vibes", "current-date"), value: "Great Vibes" },
    { label: __("Grenze", "current-date"), value: "Grenze" },
    { label: __("Griffy", "current-date"), value: "Griffy" },
    { label: __("Gruppo", "current-date"), value: "Gruppo" },
    { label: __("Gudea", "current-date"), value: "Gudea" },
    { label: __("Gugi", "current-date"), value: "Gugi" },
    { label: __("Gurajada", "current-date"), value: "Gurajada" },
    { label: __("Habibi", "current-date"), value: "Habibi" },
    { label: __("Halant", "current-date"), value: "Halant" },
    { label: __("Hammersmith One", "current-date"), value: "Hammersmith One" },
    { label: __("Hanalei", "current-date"), value: "Hanalei" },
    { label: __("Hanalei Fill", "current-date"), value: "Hanalei Fill" },
    { label: __("Handlee", "current-date"), value: "Handlee" },
    { label: __("hanna", "current-date"), value: "hanna" },
    { label: __("hannari", "current-date"), value: "hannari" },
    { label: __("Hanuman", "current-date"), value: "Hanuman" },
    { label: __("Happy Monkey", "current-date"), value: "Happy Monkey" },
    { label: __("Harmattan", "current-date"), value: "Harmattan" },
    { label: __("Headland One", "current-date"), value: "Headland One" },
    { label: __("Heebo", "current-date"), value: "Heebo" },
    { label: __("Henny Penny", "current-date"), value: "Henny Penny" },
    { label: __("Hermeneus One", "current-date"), value: "Hermeneus One" },
    { label: __("Herr Von Muellerhoff", "current-date"), value: "Herr Von Muellerhoff" },
    { label: __("Hi Melody", "current-date"), value: "Hi Melody" },
    { label: __("Hind", "current-date"), value: "Hind" },
    { label: __("Hind Colombo", "current-date"), value: "Hind Colombo" },
    { label: __("Hind Guntur", "current-date"), value: "Hind Guntur" },
    { label: __("Hind Jalandhar", "current-date"), value: "Hind Jalandhar" },
    { label: __("Hind Kochi", "current-date"), value: "Hind Kochi" },
    { label: __("Hind Madurai", "current-date"), value: "Hind Madurai" },
    { label: __("Hind Mysuru", "current-date"), value: "Hind Mysuru" },
    { label: __("Hind Siliguri", "current-date"), value: "Hind Siliguri" },
    { label: __("Hind Vadodara", "current-date"), value: "Hind Vadodara" },
    { label: __("Holtwood One SC", "current-date"), value: "Holtwood One SC" },
    { label: __("Homemade Apple", "current-date"), value: "Homemade Apple" },
    { label: __("Homenaje", "current-date"), value: "Homenaje" },
    { label: __("IBM Plex Mono", "current-date"), value: "IBM Plex Mono" },
    { label: __("IBM Plex Sans", "current-date"), value: "IBM Plex Sans" },
    { label: __("IBM Plex Sans Condensed", "current-date"), value: "IBM Plex Sans Condensed" },
    { label: __("IBM Plex Serif", "current-date"), value: "IBM Plex Serif" },
    { label: __("Iceberg", "current-date"), value: "Iceberg" },
    { label: __("Iceland", "current-date"), value: "Iceland" },
    { label: __("IM Fell Double Pica", "current-date"), value: "IM Fell Double Pica" },
    { label: __("IM Fell Double Pica SC", "current-date"), value: "IM Fell Double Pica SC" },
    { label: __("IM Fell DW Pica", "current-date"), value: "IM Fell DW Pica" },
    { label: __("IM Fell DW Pica SC", "current-date"), value: "IM Fell DW Pica SC" },
    { label: __("IM Fell English", "current-date"), value: "IM Fell English" },
    { label: __("IM Fell English SC", "current-date"), value: "IM Fell English SC" },
    { label: __("IM Fell French Canon", "current-date"), value: "IM Fell French Canon" },
    { label: __("IM Fell French Canon SC", "current-date"), value: "IM Fell French Canon SC" },
    { label: __("IM Fell Great Primer", "current-date"), value: "IM Fell Great Primer" },
    { label: __("IM Fell Great Primer SC", "current-date"), value: "IM Fell Great Primer SC" },
    { label: __("Imprima", "current-date"), value: "Imprima" },
    { label: __("Inconsolata", "current-date"), value: "Inconsolata" },
    { label: __("Inder", "current-date"), value: "Inder" },
    { label: __("Indie Flower", "current-date"), value: "Indie Flower" },
    { label: __("Inika", "current-date"), value: "Inika" },
    { label: __("Inknut Antiqua", "current-date"), value: "Inknut Antiqua" },
    { label: __("Irish Grover", "current-date"), value: "Irish Grover" },
    { label: __("Istok Web", "current-date"), value: "Istok Web" },
    { label: __("Italiana", "current-date"), value: "Italiana" },
    { label: __("Italianno", "current-date"), value: "Italianno" },
    { label: __("Itim", "current-date"), value: "Itim" },
    { label: __("Jacques Francois", "current-date"), value: "Jacques Francois" },
    { label: __("Jacques Francois Shadow", "current-date"), value: "Jacques Francois Shadow" },
    { label: __("Jaldi", "current-date"), value: "Jaldi" },
    { label: __("jejugothic", "current-date"), value: "jejugothic" },
    { label: __("jejuhallasan", "current-date"), value: "jejuhallasan" },
    { label: __("jejumyeongjo", "current-date"), value: "jejumyeongjo" },
    { label: __("Jim Nightshade", "current-date"), value: "Jim Nightshade" },
    { label: __("Jockey One", "current-date"), value: "Jockey One" },
    { label: __("Jolly Lodger", "current-date"), value: "Jolly Lodger" },
    { label: __("Jomhuria", "current-date"), value: "Jomhuria" },
    { label: __("jomolhari", "current-date"), value: "jomolhari" },
    { label: __("Josefin Sans", "current-date"), value: "Josefin Sans" },
    { label: __("Josefin Sans Std Light", "current-date"), value: "Josefin Sans Std Light" },
    { label: __("Josefin Slab", "current-date"), value: "Josefin Slab" },
    { label: __("Joti One", "current-date"), value: "Joti One" },
    { label: __("Jua", "current-date"), value: "Jua" },
    { label: __("Judson", "current-date"), value: "Judson" },
    { label: __("Julee", "current-date"), value: "Julee" },
    { label: __("Julius Sans One", "current-date"), value: "Julius Sans One" },
    { label: __("Junge", "current-date"), value: "Junge" },
    { label: __("Jura", "current-date"), value: "Jura" },
    { label: __("Just Another Hand", "current-date"), value: "Just Another Hand" },
    { label: __("Just Me Again Down Here", "current-date"), value: "Just Me Again Down Here" },
    { label: __("K2D", "current-date"), value: "K2D" },
    { label: __("Kadwa", "current-date"), value: "Kadwa" },
    { label: __("Kalam", "current-date"), value: "Kalam" },
    { label: __("Kameron", "current-date"), value: "Kameron" },
    { label: __("Kanit", "current-date"), value: "Kanit" },
    { label: __("Kantumruy", "current-date"), value: "Kantumruy" },
    { label: __("Karla", "current-date"), value: "Karla" },
    { label: __("Karla Tamil Inclined", "current-date"), value: "Karla Tamil Inclined" },
    { label: __("Karla Tamil Upright", "current-date"), value: "Karla Tamil Upright" },
    { label: __("Karma", "current-date"), value: "Karma" },
    { label: __("Katibeh", "current-date"), value: "Katibeh" },
    { label: __("Kaushan Script", "current-date"), value: "Kaushan Script" },
    { label: __("Kavivanar", "current-date"), value: "Kavivanar" },
    { label: __("Kavoon", "current-date"), value: "Kavoon" },
    { label: __("Kdam Thmor", "current-date"), value: "Kdam Thmor" },
    { label: __("Keania One", "current-date"), value: "Keania One" },
    { label: __("Kelly Slab", "current-date"), value: "Kelly Slab" },
    { label: __("Kenia", "current-date"), value: "Kenia" },
    { label: __("Khand", "current-date"), value: "Khand" },
    { label: __("Khmer", "current-date"), value: "Khmer" },
    { label: __("Khula", "current-date"), value: "Khula" },
    { label: __("khyay", "current-date"), value: "khyay" },
    { label: __("Kirang Haerang", "current-date"), value: "Kirang Haerang" },
    { label: __("Kite One", "current-date"), value: "Kite One" },
    { label: __("Knewave", "current-date"), value: "Knewave" },
    { label: __("Kodchasan", "current-date"), value: "Kodchasan" },
    { label: __("KoHo", "current-date"), value: "KoHo" },
    { label: __("kokoro", "current-date"), value: "kokoro" },
    { label: __("kopubbatang", "current-date"), value: "kopubbatang" },
    { label: __("Kotta One", "current-date"), value: "Kotta One" },
    { label: __("Koulen", "current-date"), value: "Koulen" },
    { label: __("Kranky", "current-date"), value: "Kranky" },
    { label: __("Kreon", "current-date"), value: "Kreon" },
    { label: __("Kristi", "current-date"), value: "Kristi" },
    { label: __("Krona One", "current-date"), value: "Krona One" },
    { label: __("Krub", "current-date"), value: "Krub" },
    { label: __("Kumar One", "current-date"), value: "Kumar One" },
    { label: __("Kurale", "current-date"), value: "Kurale" },
    { label: __("La Belle Aurore", "current-date"), value: "La Belle Aurore" },
    { label: __("Lacquer", "current-date"), value: "Lacquer" },
    { label: __("Laila", "current-date"), value: "Laila" },
    { label: __("Lakki Reddy", "current-date"), value: "Lakki Reddy" },
    { label: __("Lalezar", "current-date"), value: "Lalezar" },
    { label: __("Lancelot", "current-date"), value: "Lancelot" },
    { label: __("laomuangdon", "current-date"), value: "laomuangdon" },
    { label: __("laomuangkhong", "current-date"), value: "laomuangkhong" },
    { label: __("laosanspro", "current-date"), value: "laosanspro" },
    { label: __("Lateef", "current-date"), value: "Lateef" },
    { label: __("Lato", "current-date"), value: "Lato" },
    { label: __("League Script", "current-date"), value: "League Script" },
    { label: __("Leckerli One", "current-date"), value: "Leckerli One" },
    { label: __("Ledger", "current-date"), value: "Ledger" },
    { label: __("Lekton", "current-date"), value: "Lekton" },
    { label: __("Lemon", "current-date"), value: "Lemon" },
    { label: __("Lemonada", "current-date"), value: "Lemonada" },
    { label: __("Libre Barcode 128", "current-date"), value: "Libre Barcode 128" },
    { label: __("Libre Barcode 128 Text", "current-date"), value: "Libre Barcode 128 Text" },
    { label: __("Libre Barcode 39", "current-date"), value: "Libre Barcode 39" },
    { label: __("Libre Barcode 39 Extended", "current-date"), value: "Libre Barcode 39 Extended" },
    { label: __("Libre Barcode 39 Extended Text", "current-date"), value: "Libre Barcode 39 Extended Text" },
    { label: __("Libre Barcode 39 Text", "current-date"), value: "Libre Barcode 39 Text" },
    { label: __("Libre Baskerville", "current-date"), value: "Libre Baskerville" },
    { label: __("Libre Caslon Display", "current-date"), value: "Libre Caslon Display" },
    { label: __("Libre Caslon Text", "current-date"), value: "Libre Caslon Text" },
    { label: __("Libre Franklin", "current-date"), value: "Libre Franklin" },
    { label: __("Life Savers", "current-date"), value: "Life Savers" },
    { label: __("Lilita One", "current-date"), value: "Lilita One" },
    { label: __("Lily Script One", "current-date"), value: "Lily Script One" },
    { label: __("Limelight", "current-date"), value: "Limelight" },
    { label: __("Linden Hill", "current-date"), value: "Linden Hill" },
    { label: __("Literata", "current-date"), value: "Literata" },
    { label: __("Liu Jian Mao Cao", "current-date"), value: "Liu Jian Mao Cao" },
    { label: __("Livvic", "current-date"), value: "Livvic" },
    { label: __("Lobster", "current-date"), value: "Lobster" },
    { label: __("Lobster Two", "current-date"), value: "Lobster Two" },
    { label: __("Lohit Bengali", "current-date"), value: "Lohit Bengali" },
    { label: __("Lohit Tamil", "current-date"), value: "Lohit Tamil" },
    { label: __("lohitdevanagari", "current-date"), value: "lohitdevanagari" },
    { label: __("Londrina Outline", "current-date"), value: "Londrina Outline" },
    { label: __("Londrina Shadow", "current-date"), value: "Londrina Shadow" },
    { label: __("Londrina Sketch", "current-date"), value: "Londrina Sketch" },
    { label: __("Londrina Solid", "current-date"), value: "Londrina Solid" },
    { label: __("Long Cang", "current-date"), value: "Long Cang" },
    { label: __("Lora", "current-date"), value: "Lora" },
    { label: __("Love Ya Like A Sister", "current-date"), value: "Love Ya Like A Sister" },
    { label: __("Loved by the King", "current-date"), value: "Loved by the King" },
    { label: __("Lovers Quarrel", "current-date"), value: "Lovers Quarrel" },
    { label: __("Luckiest Guy", "current-date"), value: "Luckiest Guy" },
    { label: __("Lusitana", "current-date"), value: "Lusitana" },
    { label: __("Lustria", "current-date"), value: "Lustria" },
    { label: __("Ma Shan Zheng", "current-date"), value: "Ma Shan Zheng" },
    { label: __("Macondo", "current-date"), value: "Macondo" },
    { label: __("Macondo Swash Caps", "current-date"), value: "Macondo Swash Caps" },
    { label: __("Mada", "current-date"), value: "Mada" },
    { label: __("Magra", "current-date"), value: "Magra" },
    { label: __("Maiden Orange", "current-date"), value: "Maiden Orange" },
    { label: __("Maitree", "current-date"), value: "Maitree" },
    { label: __("Major Mono Display", "current-date"), value: "Major Mono Display" },
    { label: __("Mako", "current-date"), value: "Mako" },
    { label: __("Mali", "current-date"), value: "Mali" },
    { label: __("Mallanna", "current-date"), value: "Mallanna" },
    { label: __("Mandali", "current-date"), value: "Mandali" },
    { label: __("Manjari", "current-date"), value: "Manjari" },
    { label: __("Manuale", "current-date"), value: "Manuale" },
    { label: __("Marcellus", "current-date"), value: "Marcellus" },
    { label: __("Marcellus SC", "current-date"), value: "Marcellus SC" },
    { label: __("Marck Script", "current-date"), value: "Marck Script" },
    { label: __("Margarine", "current-date"), value: "Margarine" },
    { label: __("Marko One", "current-date"), value: "Marko One" },
    { label: __("Marmelad", "current-date"), value: "Marmelad" },
    { label: __("Martel", "current-date"), value: "Martel" },
    { label: __("Martel Sans", "current-date"), value: "Martel Sans" },
    { label: __("Marvel", "current-date"), value: "Marvel" },
    { label: __("Mate", "current-date"), value: "Mate" },
    { label: __("Mate SC", "current-date"), value: "Mate SC" },
    { label: __("Maven Pro", "current-date"), value: "Maven Pro" },
    { label: __("mavenprovfbeta", "current-date"), value: "mavenprovfbeta" },
    { label: __("McLaren", "current-date"), value: "McLaren" },
    { label: __("Meddon", "current-date"), value: "Meddon" },
    { label: __("MedievalSharp", "current-date"), value: "MedievalSharp" },
    { label: __("Medula One", "current-date"), value: "Medula One" },
    { label: __("Meera Inimai", "current-date"), value: "Meera Inimai" },
    { label: __("Megrim", "current-date"), value: "Megrim" },
    { label: __("Meie Script", "current-date"), value: "Meie Script" },
    { label: __("Merge One", "current-date"), value: "Merge One" },
    { label: __("Merienda", "current-date"), value: "Merienda" },
    { label: __("Merienda One", "current-date"), value: "Merienda One" },
    { label: __("Merriweather", "current-date"), value: "Merriweather" },
    { label: __("Merriweather Sans", "current-date"), value: "Merriweather Sans" },
    { label: __("Mervale Script", "current-date"), value: "Mervale Script" },
    { label: __("Metal", "current-date"), value: "Metal" },
    { label: __("Metal Mania", "current-date"), value: "Metal Mania" },
    { label: __("Metamorphous", "current-date"), value: "Metamorphous" },
    { label: __("Metrophobic", "current-date"), value: "Metrophobic" },
    { label: __("Miama", "current-date"), value: "Miama" },
    { label: __("Michroma", "current-date"), value: "Michroma" },
    { label: __("Milonga", "current-date"), value: "Milonga" },
    { label: __("Miltonian", "current-date"), value: "Miltonian" },
    { label: __("Miltonian Tattoo", "current-date"), value: "Miltonian Tattoo" },
    { label: __("Mina", "current-date"), value: "Mina" },
    { label: __("Miniver", "current-date"), value: "Miniver" },
    { label: __("Miriam Libre", "current-date"), value: "Miriam Libre" },
    { label: __("Miss Fajardose", "current-date"), value: "Miss Fajardose" },
    { label: __("Miss Saint Delafield", "current-date"), value: "Miss Saint Delafield" },
    { label: __("Modak", "current-date"), value: "Modak" },
    { label: __("Modern Antiqua", "current-date"), value: "Modern Antiqua" },
    { label: __("Molengo", "current-date"), value: "Molengo" },
    { label: __("Molle", "current-date"), value: "Molle" },
    { label: __("Monda", "current-date"), value: "Monda" },
    { label: __("Monofett", "current-date"), value: "Monofett" },
    { label: __("Monoton", "current-date"), value: "Monoton" },
    { label: __("Monsieur La Doulaise", "current-date"), value: "Monsieur La Doulaise" },
    { label: __("Montaga", "current-date"), value: "Montaga" },
    { label: __("Montez", "current-date"), value: "Montez" },
    { label: __("Montserrat", "current-date"), value: "Montserrat" },
    { label: __("Montserrat Alternates", "current-date"), value: "Montserrat Alternates" },
    { label: __("Montserrat Subrayada", "current-date"), value: "Montserrat Subrayada" },
    { label: __("Moul", "current-date"), value: "Moul" },
    { label: __("Moulpali", "current-date"), value: "Moulpali" },
    { label: __("Mountains of Christmas", "current-date"), value: "Mountains of Christmas" },
    { label: __("Mouse Memoirs", "current-date"), value: "Mouse Memoirs" },
    { label: __("mplus1p", "current-date"), value: "mplus1p" },
    { label: __("Mr Bedford", "current-date"), value: "Mr Bedford" },
    { label: __("Mr Bedfort", "current-date"), value: "Mr Bedfort" },
    { label: __("Mr Dafoe", "current-date"), value: "Mr Dafoe" },
    { label: __("Mr De Haviland", "current-date"), value: "Mr De Haviland" },
    { label: __("Mrs Saint Delafield", "current-date"), value: "Mrs Saint Delafield" },
    { label: __("Mrs Sheppards", "current-date"), value: "Mrs Sheppards" },
    { label: __("Mukta", "current-date"), value: "Mukta" },
    { label: __("Mukta Mahee", "current-date"), value: "Mukta Mahee" },
    { label: __("Mukta Malar", "current-date"), value: "Mukta Malar" },
    { label: __("Mukta Vaani", "current-date"), value: "Mukta Vaani" },
    { label: __("Muli", "current-date"), value: "Muli" },
    { label: __("myanmarsanspro", "current-date"), value: "myanmarsanspro" },
    { label: __("Mystery Quest", "current-date"), value: "Mystery Quest" },
    { label: __("Nanum Brush Script", "current-date"), value: "Nanum Brush Script" },
    { label: __("Nanum Gothic", "current-date"), value: "Nanum Gothic" },
    { label: __("Nanum Gothic Coding", "current-date"), value: "Nanum Gothic Coding" },
    { label: __("Nanum Myeongjo", "current-date"), value: "Nanum Myeongjo" },
    { label: __("Nanum Pen Script", "current-date"), value: "Nanum Pen Script" },
    { label: __("NATS", "current-date"), value: "NATS" },
    { label: __("Neucha", "current-date"), value: "Neucha" },
    { label: __("Neuton", "current-date"), value: "Neuton" },
    { label: __("New Rocker", "current-date"), value: "New Rocker" },
    { label: __("News Cycle", "current-date"), value: "News Cycle" },
    { label: __("nicomoji", "current-date"), value: "nicomoji" },
    { label: __("Niconne", "current-date"), value: "Niconne" },
    { label: __("nikukyu", "current-date"), value: "nikukyu" },
    { label: __("Niramit", "current-date"), value: "Niramit" },
    { label: __("Nixie One", "current-date"), value: "Nixie One" },
    { label: __("Nobile", "current-date"), value: "Nobile" },
    { label: __("Nokora", "current-date"), value: "Nokora" },
    { label: __("Norican", "current-date"), value: "Norican" },
    { label: __("Nosifer", "current-date"), value: "Nosifer" },
    { label: __("Nosifer Caps", "current-date"), value: "Nosifer Caps" },
    { label: __("Notable", "current-date"), value: "Notable" },
    { label: __("Nothing You Could Do", "current-date"), value: "Nothing You Could Do" },
    { label: __("Noticia Text", "current-date"), value: "Noticia Text" },
    { label: __("Noto Sans", "current-date"), value: "Noto Sans" },
    { label: __("Noto Serif", "current-date"), value: "Noto Serif" },
    { label: __("notosanstamil", "current-date"), value: "notosanstamil" },
    { label: __("Nova Cut", "current-date"), value: "Nova Cut" },
    { label: __("Nova Flat", "current-date"), value: "Nova Flat" },
    { label: __("Nova Mono", "current-date"), value: "Nova Mono" },
    { label: __("Nova Oval", "current-date"), value: "Nova Oval" },
    { label: __("Nova Round", "current-date"), value: "Nova Round" },
    { label: __("Nova Script", "current-date"), value: "Nova Script" },
    { label: __("Nova Slim", "current-date"), value: "Nova Slim" },
    { label: __("Nova Square", "current-date"), value: "Nova Square" },
    { label: __("NTR", "current-date"), value: "NTR" },
    { label: __("Numans", "current-date"), value: "Numans" },
    { label: __("Nunito", "current-date"), value: "Nunito" },
    { label: __("Nunito Sans", "current-date"), value: "Nunito Sans" },
    { label: __("Odor Mean Chey", "current-date"), value: "Odor Mean Chey" },
    { label: __("Offside", "current-date"), value: "Offside" },
    { label: __("OFL Sorts Mill Goudy TT", "current-date"), value: "OFL Sorts Mill Goudy TT" },
    { label: __("Old Standard TT", "current-date"), value: "Old Standard TT" },
    { label: __("Oldenburg", "current-date"), value: "Oldenburg" },
    { label: __("Oleo Script", "current-date"), value: "Oleo Script" },
    { label: __("Oleo Script Swash Caps", "current-date"), value: "Oleo Script Swash Caps" },
    { label: __("Open Sans", "current-date"), value: "Open Sans" },
    { label: __("Open Sans Condensed", "current-date"), value: "Open Sans Condensed" },
    { label: __("opensanshebrew", "current-date"), value: "opensanshebrew" },
    { label: __("opensanshebrewcondensed", "current-date"), value: "opensanshebrewcondensed" },
    { label: __("Oranienbaum", "current-date"), value: "Oranienbaum" },
    { label: __("Orbitron", "current-date"), value: "Orbitron" },
    { label: __("Oregano", "current-date"), value: "Oregano" },
    { label: __("Orienta", "current-date"), value: "Orienta" },
    { label: __("Original Surfer", "current-date"), value: "Original Surfer" },
    { label: __("Oswald", "current-date"), value: "Oswald" },
    { label: __("Over the Rainbow", "current-date"), value: "Over the Rainbow" },
    { label: __("Overlock", "current-date"), value: "Overlock" },
    { label: __("Overlock SC", "current-date"), value: "Overlock SC" },
    { label: __("Overpass", "current-date"), value: "Overpass" },
    { label: __("Overpass Mono", "current-date"), value: "Overpass Mono" },
    { label: __("Ovo", "current-date"), value: "Ovo" },
    { label: __("Oxygen", "current-date"), value: "Oxygen" },
    { label: __("Oxygen Mono", "current-date"), value: "Oxygen Mono" },
    { label: __("Pacifico", "current-date"), value: "Pacifico" },
    { label: __("Padauk", "current-date"), value: "Padauk" },
    { label: __("Palanquin", "current-date"), value: "Palanquin" },
    { label: __("Palanquin Dark", "current-date"), value: "Palanquin Dark" },
    { label: __("Pangolin", "current-date"), value: "Pangolin" },
    { label: __("Paprika", "current-date"), value: "Paprika" },
    { label: __("Parisienne", "current-date"), value: "Parisienne" },
    { label: __("Passero One", "current-date"), value: "Passero One" },
    { label: __("Passion One", "current-date"), value: "Passion One" },
    { label: __("Pathway Gothic One", "current-date"), value: "Pathway Gothic One" },
    { label: __("Patrick Hand", "current-date"), value: "Patrick Hand" },
    { label: __("Patrick Hand SC", "current-date"), value: "Patrick Hand SC" },
    { label: __("Pattaya", "current-date"), value: "Pattaya" },
    { label: __("Patua One", "current-date"), value: "Patua One" },
    { label: __("Pavanam", "current-date"), value: "Pavanam" },
    { label: __("Paytone One", "current-date"), value: "Paytone One" },
    { label: __("Pecita", "current-date"), value: "Pecita" },
    { label: __("Peddana", "current-date"), value: "Peddana" },
    { label: __("Peralta", "current-date"), value: "Peralta" },
    { label: __("Permanent Marker", "current-date"), value: "Permanent Marker" },
    { label: __("Petit Formal Script", "current-date"), value: "Petit Formal Script" },
    { label: __("Petrona", "current-date"), value: "Petrona" },
    { label: __("Phetsarath", "current-date"), value: "Phetsarath" },
    { label: __("Philosopher", "current-date"), value: "Philosopher" },
    { label: __("Piedra", "current-date"), value: "Piedra" },
    { label: __("Pinyon Script", "current-date"), value: "Pinyon Script" },
    { label: __("Pirata One", "current-date"), value: "Pirata One" },
    { label: __("Plaster", "current-date"), value: "Plaster" },
    { label: __("Play", "current-date"), value: "Play" },
    { label: __("Playball", "current-date"), value: "Playball" },
    { label: __("Playfair Display", "current-date"), value: "Playfair Display" },
    { label: __("Playfair Display SC", "current-date"), value: "Playfair Display SC" },
    { label: __("Podkova", "current-date"), value: "Podkova" },
    { label: __("podkovavfbeta", "current-date"), value: "podkovavfbeta" },
    { label: __("Poetsen One", "current-date"), value: "Poetsen One" },
    { label: __("Poiret One", "current-date"), value: "Poiret One" },
    { label: __("Poller One", "current-date"), value: "Poller One" },
    { label: __("Poly", "current-date"), value: "Poly" },
    { label: __("Pompiere", "current-date"), value: "Pompiere" },
    { label: __("Ponnala", "current-date"), value: "Ponnala" },
    { label: __("Pontano Sans", "current-date"), value: "Pontano Sans" },
    { label: __("Poor Story", "current-date"), value: "Poor Story" },
    { label: __("Poppins", "current-date"), value: "Poppins" },
    { label: __("Port Lligat Sans", "current-date"), value: "Port Lligat Sans" },
    { label: __("Port Lligat Slab", "current-date"), value: "Port Lligat Slab" },
    { label: __("Porter Sans Block", "current-date"), value: "Porter Sans Block" },
    { label: __("Post No Bills Colombo", "current-date"), value: "Post No Bills Colombo" },
    { label: __("Post No Bills Jaffna", "current-date"), value: "Post No Bills Jaffna" },
    { label: __("Pragati Narrow", "current-date"), value: "Pragati Narrow" },
    { label: __("Preahvihear", "current-date"), value: "Preahvihear" },
    { label: __("Press Start 2P", "current-date"), value: "Press Start 2P" },
    { label: __("Pridi", "current-date"), value: "Pridi" },
    { label: __("Princess Sofia", "current-date"), value: "Princess Sofia" },
    { label: __("Prociono", "current-date"), value: "Prociono" },
    { label: __("Prompt", "current-date"), value: "Prompt" },
    { label: __("Prosto One", "current-date"), value: "Prosto One" },
    { label: __("Proza Libre", "current-date"), value: "Proza Libre" },
    { label: __("PT Mono", "current-date"), value: "PT Mono" },
    { label: __("PT Sans", "current-date"), value: "PT Sans" },
    { label: __("PT Sans Caption", "current-date"), value: "PT Sans Caption" },
    { label: __("PT Sans Narrow", "current-date"), value: "PT Sans Narrow" },
    { label: __("PT Serif", "current-date"), value: "PT Serif" },
    { label: __("PT Serif Caption", "current-date"), value: "PT Serif Caption" },
    { label: __("Puritan", "current-date"), value: "Puritan" },
    { label: __("Purple Purse", "current-date"), value: "Purple Purse" },
    { label: __("Pushster", "current-date"), value: "Pushster" },
    { label: "Quando", value: "Quando" },
    { label: "Quantico", value: "Quantico" },
    { label: "Quattrocento", value: "Quattrocento" },
    { label: "Quattrocento Sans", value: "Quattrocento Sans" },
    { label: "Questrial", value: "Questrial" },
    { label: "Quicksand", value: "Quicksand" },
    { label: "Quintessential", value: "Quintessential" },
    { label: "Qwigley", value: "Qwigley" },
    { label: "Racing Sans One", value: "Racing Sans One" },
    { label: "Radley", value: "Radley" },
    { label: "Rajdhani", value: "Rajdhani" },
    { label: "Rakkas", value: "Rakkas" },
    { label: "Raleway", value: "Raleway" },
    { label: "Raleway Dots", value: "Raleway Dots" },
    { label: "Ramabhadra", value: "Ramabhadra" },
    { label: "Ramaraja", value: "Ramaraja" },
    { label: "Rambla", value: "Rambla" },
    { label: "Rammetto One", value: "Rammetto One" },
    { label: "Ranchers", value: "Ranchers" },
    { label: "Rancho", value: "Rancho" },
    { label: "Ranga", value: "Ranga" },
    { label: "Rasa", value: "Rasa" },
    { label: "Rationale", value: "Rationale" },
    { label: "Ravi Prakash", value: "Ravi Prakash" },
    { label: "Red Hat Display", value: "Red Hat Display" },
    { label: "Red Hat Text", value: "Red Hat Text" },
    { label: "Redacted", value: "Redacted" },
    { label: "Redacted Script", value: "Redacted Script" },
    { label: "Redressed", value: "Redressed" },
    { label: "Reem Kufi", value: "Reem Kufi" },
    { label: "Reenie Beanie", value: "Reenie Beanie" },
    { label: "Revalia", value: "Revalia" },
    { label: "Rhodium Libre", value: "Rhodium Libre" },
    { label: "Ribeye", value: "Ribeye" },
    { label: "Ribeye Marrow", value: "Ribeye Marrow" },
    { label: "Righteous", value: "Righteous" },
    { label: "Risque", value: "Risque" },
    { label: "Roboto", value: "Roboto" },
    { label: "Roboto Condensed", value: "Roboto Condensed" },
    { label: "Roboto Mono", value: "Roboto Mono" },
    { label: "Roboto Slab", value: "Roboto Slab" },
    { label: "Rochester", value: "Rochester" },
    { label: "Rock Salt", value: "Rock Salt" },
    { label: "Rokkitt", value: "Rokkitt" },
    { label: "Romanesco", value: "Romanesco" },
    { label: "Ropa Sans", value: "Ropa Sans" },
    { label: "Rosario", value: "Rosario" },
    { label: "Rosarivo", value: "Rosarivo" },
    { label: "Rouge Script", value: "Rouge Script" },
    { label: "roundedmplus1c", value: "roundedmplus1c" },
    { label: "Rozha One", value: "Rozha One" },
    { label: "Rubik", value: "Rubik" },
    { label: "Rubik Mono One", value: "Rubik Mono One" },
    { label: "Rubik One", value: "Rubik One" },
    { label: "Ruda", value: "Ruda" },
    { label: "Rufina", value: "Rufina" },
    { label: "Ruge Boogie", value: "Ruge Boogie" },
    { label: "Ruluko", value: "Ruluko" },
    { label: "Rum Raisin", value: "Rum Raisin" },
    { label: "Ruslan Display", value: "Ruslan Display" },
    { label: "Russo One", value: "Russo One" },
    { label: "Ruthie", value: "Ruthie" },
    { label: "Rye", value: "Rye" },
    { label: __("Sacramento", "current-date"), value: "Sacramento" },
    { label: __("Sahitya", "current-date"), value: "Sahitya" },
    { label: __("Sail", "current-date"), value: "Sail" },
    { label: __("Saira", "current-date"), value: "Saira" },
    { label: __("Saira Condensed", "current-date"), value: "Saira Condensed" },
    { label: __("Saira Extra Condensed", "current-date"), value: "Saira Extra Condensed" },
    { label: __("Saira Semi Condensed", "current-date"), value: "Saira Semi Condensed" },
    { label: __("Saira Stencil One", "current-date"), value: "Saira Stencil One" },
    { label: __("Salsa", "current-date"), value: "Salsa" },
    { label: __("Sanchez", "current-date"), value: "Sanchez" },
    { label: __("Sancreek", "current-date"), value: "Sancreek" },
    { label: __("Sansation", "current-date"), value: "Sansation" },
    { label: __("Sansita", "current-date"), value: "Sansita" },
    { label: __("Sansita One", "current-date"), value: "Sansita One" },
    { label: __("Sarabun", "current-date"), value: "Sarabun" },
    { label: __("Sarala", "current-date"), value: "Sarala" },
    { label: __("Sarina", "current-date"), value: "Sarina" },
    { label: __("Sarpanch", "current-date"), value: "Sarpanch" },
    { label: __("Satisfy", "current-date"), value: "Satisfy" },
    { label: __("sawarabigothic", "current-date"), value: "sawarabigothic" },
    { label: __("sawarabimincho", "current-date"), value: "sawarabimincho" },
    { label: __("Scada", "current-date"), value: "Scada" },
    { label: __("Scheherazade", "current-date"), value: "Scheherazade" },
    { label: __("Schoolbell", "current-date"), value: "Schoolbell" },
    { label: __("Scope One", "current-date"), value: "Scope One" },
    { label: __("Seaweed Script", "current-date"), value: "Seaweed Script" },
    { label: __("Secular One", "current-date"), value: "Secular One" },
    { label: __("Sedan", "current-date"), value: "Sedan" },
    { label: __("Sedan SC", "current-date"), value: "Sedan SC" },
    { label: __("Sedgwick Ave", "current-date"), value: "Sedgwick Ave" },
    { label: __("Sedgwick Ave Display", "current-date"), value: "Sedgwick Ave Display" },
    { label: __("seoulhangang", "current-date"), value: "seoulhangang" },
    { label: __("seoulhangangcondensed", "current-date"), value: "seoulhangangcondensed" },
    { label: __("seoulnamsan", "current-date"), value: "seoulnamsan" },
    { label: __("seoulnamsancondensed", "current-date"), value: "seoulnamsancondensed" },
    { label: __("seoulnamsanvertical", "current-date"), value: "seoulnamsanvertical" },
    { label: __("Sevillana", "current-date"), value: "Sevillana" },
    { label: __("Seymour One", "current-date"), value: "Seymour One" },
    { label: __("Shadows Into Light", "current-date"), value: "Shadows Into Light" },
    { label: __("Shadows Into Light Two", "current-date"), value: "Shadows Into Light Two" },
    { label: __("Shanti", "current-date"), value: "Shanti" },
    { label: __("Share", "current-date"), value: "Share" },
    { label: __("Share Tech", "current-date"), value: "Share Tech" },
    { label: __("Share Tech Mono", "current-date"), value: "Share Tech Mono" },
    { label: __("Shojumaru", "current-date"), value: "Shojumaru" },
    { label: __("Short Stack", "current-date"), value: "Short Stack" },
    { label: __("Shrikhand", "current-date"), value: "Shrikhand" },
    { label: __("Siamreap", "current-date"), value: "Siamreap" },
    { label: __("Siemreap", "current-date"), value: "Siemreap" },
    { label: __("Sigmar One", "current-date"), value: "Sigmar One" },
    { label: __("Signika", "current-date"), value: "Signika" },
    { label: __("Signika Negative", "current-date"), value: "Signika Negative" },
    { label: __("Simonetta", "current-date"), value: "Simonetta" },
    { label: __("Single Day", "current-date"), value: "Single Day" },
    { label: __("Sintony", "current-date"), value: "Sintony" },
    { label: __("Sirin Stencil", "current-date"), value: "Sirin Stencil" },
    { label: __("Sitara", "current-date"), value: "Sitara" },
    { label: __("Six Caps", "current-date"), value: "Six Caps" },
    { label: __("Skranji", "current-date"), value: "Skranji" },
    { label: __("Slabo 13px", "current-date"), value: "Slabo 13px" },
    { label: __("Slabo 27px", "current-date"), value: "Slabo 27px" },
    { label: __("Slackey", "current-date"), value: "Slackey" },
    { label: __("Smokum", "current-date"), value: "Smokum" },
    { label: __("Smythe", "current-date"), value: "Smythe" },
    { label: __("Sniglet", "current-date"), value: "Sniglet" },
    { label: __("Snippet", "current-date"), value: "Snippet" },
    { label: __("Snowburst One", "current-date"), value: "Snowburst One" },
    { label: __("Sofadi One", "current-date"), value: "Sofadi One" },
    { label: __("Sofia", "current-date"), value: "Sofia" },
    { label: __("Solway", "current-date"), value: "Solway" },
    { label: __("Song Myung", "current-date"), value: "Song Myung" },
    { label: __("Sonsie One", "current-date"), value: "Sonsie One" },
    { label: __("Sorts Mill Goudy", "current-date"), value: "Sorts Mill Goudy" },
    { label: __("souliyo", "current-date"), value: "souliyo" },
    { label: __("Source Code Pro", "current-date"), value: "Source Code Pro" },
    { label: __("Source Sans Pro", "current-date"), value: "Source Sans Pro" },
    { label: __("Source Serif Pro", "current-date"), value: "Source Serif Pro" },
    { label: __("Space Mono", "current-date"), value: "Space Mono" },
    { label: __("Special Elite", "current-date"), value: "Special Elite" },
    { label: __("Spectral", "current-date"), value: "Spectral" },
    { label: __("Spicy Rice", "current-date"), value: "Spicy Rice" },
    { label: __("Spinnaker", "current-date"), value: "Spinnaker" },
    { label: __("Spirax", "current-date"), value: "Spirax" },
    { label: __("Squada One", "current-date"), value: "Squada One" },
    { label: __("Sree Krushnadevaraya", "current-date"), value: "Sree Krushnadevaraya" },
    { label: __("Sriracha", "current-date"), value: "Sriracha" },
    { label: __("Srisakdi", "current-date"), value: "Srisakdi" },
    { label: __("Staatliches", "current-date"), value: "Staatliches" },
    { label: __("Stalemate", "current-date"), value: "Stalemate" },
    { label: __("Stalin One", "current-date"), value: "Stalin One" },
    { label: __("Stalinist One", "current-date"), value: "Stalinist One" },
    { label: __("Stardos Stencil", "current-date"), value: "Stardos Stencil" },
    { label: __("Stint Ultra Condensed", "current-date"), value: "Stint Ultra Condensed" },
    { label: __("Stint Ultra Expanded", "current-date"), value: "Stint Ultra Expanded" },
    { label: __("Stoke", "current-date"), value: "Stoke" },
    { label: __("Strait", "current-date"), value: "Strait" },
    { label: __("Strong", "current-date"), value: "Strong" },
    { label: __("Stylish", "current-date"), value: "Stylish" },
    { label: __("Sue Ellen Francisco", "current-date"), value: "Sue Ellen Francisco" },
    { label: __("Suez One", "current-date"), value: "Suez One" },
    { label: __("Sumana", "current-date"), value: "Sumana" },
    { label: __("Sunflower", "current-date"), value: "Sunflower" },
    { label: __("Sunshiney", "current-date"), value: "Sunshiney" },
    { label: __("Supermercado One", "current-date"), value: "Supermercado One" },
    { label: __("Sura", "current-date"), value: "Sura" },
    { label: __("Suranna", "current-date"), value: "Suranna" },
    { label: __("Suravaram", "current-date"), value: "Suravaram" },
    { label: __("Suwannaphum", "current-date"), value: "Suwannaphum" },
    { label: __("Swanky and Moo Moo", "current-date"), value: "Swanky and Moo Moo" },
    { label: __("Syncopate", "current-date"), value: "Syncopate" },
    { label: __("Tajawal", "current-date"), value: "Tajawal" },
    { label: __("Tangerine", "current-date"), value: "Tangerine" },
    { label: __("Taprom", "current-date"), value: "Taprom" },
    { label: __("Tauri", "current-date"), value: "Tauri" },
    { label: __("Taviraj", "current-date"), value: "Taviraj" },
    { label: __("Teko", "current-date"), value: "Teko" },
    { label: __("Telex", "current-date"), value: "Telex" },
    { label: __("Tenali Ramakrishna", "current-date"), value: "Tenali Ramakrishna" },
    { label: __("Tenor Sans", "current-date"), value: "Tenor Sans" },
    { label: __("Terminal Dosis", "current-date"), value: "Terminal Dosis" },
    { label: __("Terminal Dosis Light", "current-date"), value: "Terminal Dosis Light" },
    { label: __("Text Me One", "current-date"), value: "Text Me One" },
    { label: __("Thabit", "current-date"), value: "Thabit" },
    { label: __("tharlon", "current-date"), value: "tharlon" },
    { label: __("Thasadith", "current-date"), value: "Thasadith" },
    { label: __("The Girl Next Door", "current-date"), value: "The Girl Next Door" },
    { label: __("Tienne", "current-date"), value: "Tienne" },
    { label: __("Tillana", "current-date"), value: "Tillana" },
    { label: __("Timmana", "current-date"), value: "Timmana" },
    { label: __("Tinos", "current-date"), value: "Tinos" },
    { label: __("Titan One", "current-date"), value: "Titan One" },
    { label: __("Titillium Web", "current-date"), value: "Titillium Web" },
    { label: __("Trade Winds", "current-date"), value: "Trade Winds" },
    { label: __("Trirong", "current-date"), value: "Trirong" },
    { label: __("Trocchi", "current-date"), value: "Trocchi" },
    { label: __("Trochut", "current-date"), value: "Trochut" },
    { label: __("Trykker", "current-date"), value: "Trykker" },
    { label: __("Tuffy", "current-date"), value: "Tuffy" },
    { label: __("Tulpen One", "current-date"), value: "Tulpen One" },
    { label: __("Ubuntu", "current-date"), value: "Ubuntu" },
    { label: __("Ubuntu Condensed", "current-date"), value: "Ubuntu Condensed" },
    { label: __("Ubuntu Mono", "current-date"), value: "Ubuntu Mono" },
    { label: __("Ultra", "current-date"), value: "Ultra" },
    { label: __("Uncial Antiqua", "current-date"), value: "Uncial Antiqua" },
    { label: __("Underdog", "current-date"), value: "Underdog" },
    { label: __("Unica One", "current-date"), value: "Unica One" },
    { label: __("UnifrakturCook", "current-date"), value: "UnifrakturCook" },
    { label: __("UnifrakturMaguntia", "current-date"), value: "UnifrakturMaguntia" },
    { label: __("Unkempt", "current-date"), value: "Unkempt" },
    { label: __("Unlock", "current-date"), value: "Unlock" },
    { label: __("Unna", "current-date"), value: "Unna" },
    { label: __("Vampiro One", "current-date"), value: "Vampiro One" },
    { label: __("Varela", "current-date"), value: "Varela" },
    { label: __("Varela Round", "current-date"), value: "Varela Round" },
    { label: __("Varta", "current-date"), value: "Varta" },
    { label: __("Vast Shadow", "current-date"), value: "Vast Shadow" },
    { label: __("Vesper Libre", "current-date"), value: "Vesper Libre" },
    { label: __("Vibur", "current-date"), value: "Vibur" },
    { label: __("Vidaloka", "current-date"), value: "Vidaloka" },
    { label: __("Viga", "current-date"), value: "Viga" },
    { label: __("Voces", "current-date"), value: "Voces" },
    { label: __("Volkhov", "current-date"), value: "Volkhov" },
    { label: __("Vollkorn", "current-date"), value: "Vollkorn" },
    { label: __("Vollkorn SC", "current-date"), value: "Vollkorn SC" },
    { label: __("Voltaire", "current-date"), value: "Voltaire" },
    { label: __("VT323", "current-date"), value: "VT323" },
    { label: __("Waiting for the Sunrise", "current-date"), value: "Waiting for the Sunrise" },
    { label: __("Wallpoet", "current-date"), value: "Wallpoet" },
    { label: __("Walter Turncoat", "current-date"), value: "Walter Turncoat" },
    { label: __("Warnes", "current-date"), value: "Warnes" },
    { label: __("Wellfleet", "current-date"), value: "Wellfleet" },
    { label: __("Wendy One", "current-date"), value: "Wendy One" },
    { label: __("Wire One", "current-date"), value: "Wire One" },
    { label: __("Work Sans", "current-date"), value: "Work Sans" },
    { label: __("Yaldevi Colombo", "current-date"), value: "Yaldevi Colombo" },
    { label: __("Yanone Kaffeesatz", "current-date"), value: "Yanone Kaffeesatz" },
    { label: __("Yantramanav", "current-date"), value: "Yantramanav" },
    { label: __("Yatra One", "current-date"), value: "Yatra One" },
    { label: __("Yellowtail", "current-date"), value: "Yellowtail" },
    { label: __("Yeon Sung", "current-date"), value: "Yeon Sung" },
    { label: __("Yeseva One", "current-date"), value: "Yeseva One" },
    { label: __("Yesteryear", "current-date"), value: "Yesteryear" },
    { label: __("Yinmar", "current-date"), value: "Yinmar" },
    { label: __("Yrsa", "current-date"), value: "Yrsa" },
    { label: __("ZCOOL KuaiLe", "current-date"), value: "ZCOOL KuaiLe" },
    { label: __("ZCOOL QingKe HuangYou", "current-date"), value: "ZCOOL QingKe HuangYou" },
    { label: __("ZCOOL XiaoWei", "current-date"), value: "ZCOOL XiaoWei" },
    { label: __("Zeyada", "current-date"), value: "Zeyada" },
    { label: __("Zhi Mang Xing", "current-date"), value: "Zhi Mang Xing" },
    { label: __("Zilla Slab Highlight", "current-date"), value: "Zilla Slab Highlight" },
];
